export const createGroupStructureUp = (groupData, parsedSettings) => {
  const selectedCapabilities = groupData.length >= 4 ? 3 : 8;

  const horabusDecimal = groupData[0].Horabus;
  const totalMinutes = Math.floor(horabusDecimal * 24 * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const formattedHorabus = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

  const groupStructure = {
    //+++=========================================+++
    // ++==Inicio Datos de Prueba DEMODIGITAL ==++
    // customerId: 144,
    // displayName: "Demo (Digital)",
    // accountCode: "0001",
    // ++== FIN Datos de Prueba DEMODIGITAL ==++
    //+++=========================================+++
    customerId: parsedSettings.clienteId,
    accountCode: parsedSettings.accountCode,
    displayName: parsedSettings.displayName,

    companyId: parsedSettings.companyId,
    paymentType: "Account",
    pickupDueTime: new Date(`${groupData[0].FechaProgramado}T${groupData[0].HoraProgramado}`),
    name: groupData[0].Nombre.toUpperCase(),
    passengers: groupData.length,
    telephoneNumber: groupData[0].Telefono,
    capabilities: [selectedCapabilities],

    accountType: "Account",
    driverNote: `ESPERAR 2 MINUTOS POR DOMICILIO-ESPERAR QUE SUBA AL BUS ${formattedHorabus}`,
    priority: 5,
    pickup: {
      address: {
        text: groupData[0].origin.address.toUpperCase(),
        coordinate: {
          latitude: groupData[0].origin.latitude,
          longitude: groupData[0].origin.longitude,
        },
        street: groupData[0].origin.address.toUpperCase(),
      },
      passengerDetailsIndex: 0,
      type: "Pickup",
    },
    vias: groupData.slice(1).map((pasajero, index) => ({
      address: {
        text: pasajero.origin.address.toUpperCase(),
        coordinate: {
          latitude: pasajero.origin.latitude,
          longitude: pasajero.origin.longitude,
        },
        street: pasajero.Origen.toUpperCase(),
      },
      note: "",
      passengerDetailsIndex: index + 1,
      type: "Pickup",
    })),
    extraPassengerDetails: groupData.slice(1).map((pasajero, index) => ({
      customerId: null,
      driverNote: "",
      dropOffTime: null,
      name: `${pasajero.Nombre.toUpperCase()} / ${pasajero.Rut}`,
      ourReference: index + 1,
      pickupDueTime: new Date(`${pasajero.FechaProgramado}T${pasajero.HoraProgramado}`).toISOString(),
      ringTextRequests: 0,
      telephoneNumber: pasajero.Telefono,
      yourReference: "",
      hasDestination: false,
    })),
    destination: {
      address: {
        text: groupData[0].destination.address.toUpperCase(),
        zoneId: groupData[0].destination.zoneId,
        coordinate: {
          latitude: groupData[0].destination.latitude,
          longitude: groupData[0].destination.longitude,
        },
        street: groupData[0].destination.address.toUpperCase(),
      },
      note: "",
      passengerDetailsIndex: 0,
      type: "Destination",
    },
    yourReferences: {
      yourReference5: groupData[0].Solicitante,
      yourReference2: groupData[0].Rut,
      yourReference6: `${groupData
        .slice(1) // saltar el primer pasajero
        .map((pasajero) => `${pasajero.Nombre}/${pasajero.Rut}`)
        .join("/")}.`.toUpperCase(),

      yourReference3: groupData[0].NG,
      yourReference4: groupData[0].OS,
      yourReference7: groupData[0].Motivo,
    },
    priorityOverride: true,
    hold: true,
  };

  return groupStructure;
};
